export default "__VITE_ASSET__Bke$a4np__"